import { defineStore } from 'pinia';
export const newsStore = defineStore('newsStore',{
    state: () => ({

    }),
    actions: {
        updateConsolidatedNewsList() {
            //TODO
        }
    }
});